import axios from 'axios'
const CHAT_API_BASE_URL = `${process.env.REACT_APP_CHAT_API_URL}`

export const getChatsCount = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/get/user-chats-count`, data)
}

export const getUserMessagesCount = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/get/total/user/send-messages/count`, data)
}

export const createChat = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/create/chat`, data)
}

export const deleteChat = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/delete/chat`, data)
}

export const blockChat = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/block/chat`, data)
}

export const unblockChat = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/unblock/chat`, data)
}

// New Functions
export const getUserChats = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/get/user-chats`, data)
}

export const getUserChatMessages = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/get/messages`, data)
}

export const createMessage = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/create/message`, data)
}

export const getUnreadChatsCount = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/get/unread/user/messages/count`, data)
}

export const readChat = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/mark/messages/read`, data)
}
